/**
 * Guided checkpoint polling policy. A legitimate pending review is never timed
 * out (successful reads keep polling indefinitely); only CONSECUTIVE read
 * failures are bounded, after which polling stops and the presenter is shown
 * a Retry/Exit error.
 */
export const CHECKPOINT_MAX_READ_FAILURES = 5;

export type PollRead = { ok: true; status: string } | { ok: false; reason: string };
export type PollStep =
  | { action: 'confirm'; failures: 0 }
  | { action: 'wait'; failures: number }
  | { action: 'error'; failures: number; message: string };

export function nextCheckpointPoll(failures: number, res: PollRead, expected: string): PollStep {
  if (res.ok === true) return res.status === expected ? { action: 'confirm', failures: 0 } : { action: 'wait', failures: 0 };
  const n = failures + 1;
  if (n >= CHECKPOINT_MAX_READ_FAILURES) {
    return { action: 'error', failures: n, message: `The saved review could not be read (${(res as { reason: string }).reason}). Retry, or exit the walkthrough.` };
  }
  return { action: 'wait', failures: n };
}
